import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";

import api from "../../../providers/api";

import LoadingPanel from "../../../components/loading-painel";

import Layout from "../../../layout";

import validateCadastrar from "./form-validate-cadastrar";
import validateEditar from "./form-validate-editar";

const UsuarioCadastrar = () => {
  const location = useLocation();
  const history = useHistory();

  const [state, setState] = useState({
    id: 0,
    nome: "",
    email: "",
    senha: "",
    ativo: true,
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-usuario").valid()) {
      return;
    }

    try {
      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/usuario", state);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/usuario");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar o usuário.");
    }
  };

  useEffect(() => {
    const carregarDados = async () => {
      if (!location.state) {
        return;
      }

      try {
        showLoading(".ibox-content");

        const requisicao = await api.get(`/usuario/${location.state.id}`);

        const { data } = requisicao;

        if (!data.status) {
          danger(data.mensagem);
          return;
        }

        if (!data.data) {
          return;
        }

        setState(data.data);
        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados do usuário");
      }
    };

    let validacao = window
      .$("#form-usuario")
      .validate(!location.state ? validateCadastrar : validateEditar);

    carregarDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Usuários"
        header="Cadastro do Usuário"
        action={{ titulo: "Voltar", link: "/usuario" }}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Dados do usuário</h5>
              </div>
              <div className="ibox-content">
                <LoadingPanel />
                <div className="row">
                  <div className="col-lg-12">
                    <form id="form-usuario">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-lg-3">
                            <label>Nome do usuário</label>
                            <input
                              type="text"
                              placeholder="Nome do usuário"
                              className="form-control"
                              name="nome"
                              value={state.nome}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                          <div className="col-lg-4">
                            <label>Email do usuário</label>
                            <input
                              type="text"
                              placeholder="Email do usuário"
                              className="form-control"
                              name="email"
                              value={state.email}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                          <div className="col-lg-3">
                            <label>Senha do usuário</label>
                            <input
                              type="password"
                              placeholder="Senha do usuário"
                              className="form-control"
                              name="senha"
                              value={state.senha}
                              onChange={(e) => preencherValoresEdits(e)}
                            />
                          </div>
                          <div className="col-lg-2">
                            <label>Status do usuário</label>
                            <select
                              className="form-control"
                              id="ativo"
                              name="ativo"
                              value={state.ativo}
                              onChange={(e) => preencherValoresEdits(e)}
                            >
                              <option key="1" value={true}>
                                Ativo
                              </option>

                              <option key="2" value={false}>
                                Inativo
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div>
                        <button
                          className="btn btn-sm btn-success float-right m-t-n-xs"
                          type="submit"
                          onClick={(e) => enviarFormulario(e)}
                        >
                          <strong>Salvar</strong>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default UsuarioCadastrar;
